<template>
	<div class="subMain">
		<Banner />
		<div class="maxBox">
			<div class="subtabList">
				<ul>
					<!-- <li :class="{'active':active=='/introduce/aboutus'}">
						<router-link to="/introduce/aboutus">
							公司简介
							<span><el-icon><ArrowRightBold /></el-icon></span>
						</router-link>
					</li> -->
					<li :class="{'active':active.indexOf('/introduce/news') > -1}">
						<router-link to="/introduce/news">
							奇葩大事件
							<span><el-icon><ArrowRightBold /></el-icon></span>
						</router-link>
					</li>
				</ul>
			</div>
			<div class="subContent">
				<div class="subPageTitle">
					<h4>{{ activeTitle }}</h4>
					<div class="breadcrumb">
						<el-breadcrumb :separator-icon="ArrowRight">
						    <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						    <el-breadcrumb-item>走进奇葩</el-breadcrumb-item>
						    <el-breadcrumb-item>{{ activeTitle }}</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</div>
				<router-view :key="key" />
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, computed } from 'vue'
	import { useRoute } from 'vue-router'
	import { ArrowRight,ArrowRightBold } from '@element-plus/icons-vue'
	import Banner from '@/components/banner/Index.vue'
	const router = useRoute();
	const active = ref(router.path);
	const activeTitle = ref(router.meta.title);
	const key = computed(() => {
		return router.path
	})
</script>
<style lang="less">
  @import '@/assets/css/common';
</style>
<style lang="less" scoped>

</style>
